export default __webpack_public_path__ + "static/media/Company.f8eb5c81.svg";